import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { useWSMutation } from "../../helpers";
import { WSServiceError } from "../../../utils/serviceHelper";
import { QUERY_CARD } from "../queries/useQueryCard";
import { QUERY_CARDS } from "../queries/useQueryCards";
import { activateCard } from "../../../services/api/banking/cards/activateCard";

export const useMutationActivateCard = () =>
  useWSMutation<
    cardApiSpec.Card,
    WSServiceError,
    {
      cardId: string;
    } & cardApiSpec.ActivateCardRequest
  >(
    ({ cardId, ...request }) => {
      return activateCard(cardId, request);
    },
    {
      dependencies(response, { cardId }) {
        return [[QUERY_CARD, cardId], QUERY_CARDS];
      }
    }
  );
